import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy slug — permanent redirect to the canonical ES URL. */
export const Route = createFileRoute("/mentoria")({
  beforeLoad: () => {
    throw redirect({ to: "/mentoria-retail", statusCode: 301 });
  },
});
